var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSprout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7496 5.42558C34.5521 7.74915 33.8897 11.9525 31.6667 14C29.7681 15.7487 25.6033 16.9706 22.5687 17.6698C21.1633 17.9935 20.1875 19.1594 20.1875 20.4938V30.4063C20.1875 30.8089 19.833 31.1354 19.3958 31.1354H18.6042C18.167 31.1354 17.8125 30.8089 17.8125 30.4063V20.4938C17.8125 19.1596 16.8367 17.9935 15.4313 17.6698C12.3967 16.9706 8.23192 15.7487 6.33334 14C4.11034 11.9525 3.44787 7.749 3.25043 5.42558C3.17538 4.54125 3.98051 3.79969 4.94064 3.86896C7.46321 4.05081 12.027 4.66098 14.25 6.70848C17.2134 9.4379 18.5807 13.3019 19 15.8231C19 15.8231 20.7866 9.4379 23.75 6.70848C25.973 4.66098 30.5368 4.05081 33.0594 3.86896C34.0195 3.79969 34.8246 4.54125 34.7496 5.42558Z",
    fill: "#96D27D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprout);
export default __webpack_public_path__ + "static/media/sprout.c7748e30b65dc85c69d51e471d138e68.svg";
export { ForwardRef as ReactComponent };